import React from 'react';
import { useLocation } from 'react-router-dom';
import AddMastercertificate from './components/AddMastercertificate';
import type { MasterCertificate } from './hooks/useMasterCertificates';

export default function MasterCertificatePage() {
  const location = useLocation();
  const editCert: MasterCertificate | null = (location.state as any)?.editCert ?? null;
  return <AddMastercertificate editCert={editCert} />;
}
